
export const getFilenameFromLink = (fileLink) => {
  return (fileLink && fileLink.split("?")[0].split("/").pop()) || "";
}
